import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19.5 12a2.34 2.34 0 0 1-.78 1.73L7.57 23.54a1.85 1.85 0 1 1-2.44-2.77l9.75-8.58a.25.25 0 0 0 0-.38L5.13 3.23A1.85 1.85 0 1 1 7.57.46l11.15 9.81A2.34 2.34 0 0 1 19.5 12Z"
}), 'ChevronRight');